/* eslint-disable */
import { useTranslation as useUiTranslation } from "react-i18next";
import React, { useEffect, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { useSelector } from "react-redux";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import {
  query,
  collection,
  where,
  getDocs,
  doc,
  updateDoc,
  Timestamp,
} from "firebase/firestore";
import { db, auth } from "../../../firebase";
import Swal from "sweetalert2";

const ModalAdd = ({
  lgShowE,
  setLgShowE,
  dataForm,
  setDataForm,
  confirmUserId,
}) => {
  const { t: uiT } = useUiTranslation();
  const store = useSelector((state) => state.StoreReducer);
  const currentUser = auth.currentUser; // المستخدم الحالي
  const [documentId, setDocumentId] = useState(null);

  useEffect(() => {
    const fetchDocumentId = async () => {
      if (currentUser) {
        const q = query(
          collection(db, "confirmers"),
          where("user", "==", currentUser.uid)
        );
        const querySnapshot = await getDocs(q);
        if (!querySnapshot.empty) {
          setDocumentId(querySnapshot.docs[0].id);
        }
      }
    };

    fetchDocumentId();
  }, [currentUser]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (dataForm.documentId) {
        // استخدام documentId
        const docRef = doc(db, "confirmers", dataForm.documentId);
        await updateDoc(docRef, {
          name: dataForm.name,
          phone: dataForm.phone,
          pricing: {
            confirmPrice: dataForm?.pricing?.confirmPrice || 0,
            cancelPrice: dataForm?.pricing?.cancelPrice || 0,
          },
          baridimobKey: dataForm.baridimobKey,
        });

        Swal.fire({
          icon: "success",
          title: uiT("ui.confirmerUpdated"),
          showConfirmButton: false,
          timer: 1500,
          confirmButtonColor: "#02bc7d",
        });

        setLgShowE(false);
        setDataForm({});
      } else {
        Swal.fire({
          icon: "error",
          title: uiT("ui.documentMissing"),
          confirmButtonColor: "#02bc7d",
        });
      }
    } catch (error) {
      console.error("Error updating document: ", error);
      Swal.fire({
        icon: "error",
        title: uiT("ui.confirmerUpdateError"),
        confirmButtonColor: "#02bc7d",
      });
    }
  };

  return (
    <Modal
      size="lg"
      show={lgShowE}
      onHide={() => setLgShowE(false)}
      aria-labelledby="example-modal-sizes-title-lg"

      className="w-100"
    >
      <Form onSubmit={handleSubmit}>
          <div className="text-white bg-[#a070b9] modal-header">
                  <Modal.Title id="example-modal-sizes-title-lg">{uiT("ui.editConfirmer")}  </Modal.Title>
                </div>
        <Modal.Body>
        <div className="border border-gray-300 rounded-lg w-full bg-white flex flex-col gap-2 my-3">
          {/* Header */}
          <div className="flex items-center justify-between bg-[#fbf5ff] p-2 rounded-lg border-b border-[#eee] ">
            <div className="flex items-center gap-2">
              <button className="text-red-500 hover:text-red-700 p-1">
                <span className="text-xl">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#d5d5d5" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-user-pen"><path d="M11.5 15H7a4 4 0 0 0-4 4v2" /><path d="M21.378 16.626a1 1 0 0 0-3.004-3.004l-4.01 4.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z" /><circle cx="10" cy="7" r="4" /></svg>
                </span>
              </button>
              <span className="text-gray-700 font-medium">
                {" "}
                {uiT("ui.confirmerInfo")}
              </span>
            </div>
            <div className="flex items-center gap-2">
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip>
                    {" "}
                    {uiT("ui.emailReadOnly")}
                  </Tooltip>
                }
              >
                <i className="bi bi-info-circle-fill text-[#0866ff] text-xl"></i>
              </OverlayTrigger>
            </div>
          </div>

          <div className="row gap-3  p-2">


            <div className="flex flex-nowrap items-center gap-3 w-full">


              <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
                <div>
                  <label className="text-[#444] text-[13px] font-medium mb-1">
                    {uiT("ui.fullName")}
                  </label>
                  <div className="relative mb-1">
                    <div className="absolute inset-y-0 start-0 flex items-center ps-3.5 pointer-events-none">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#d5d5d5" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-user"><path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" /><circle cx="12" cy="7" r="4" /></svg>
                    </div>
                    <input
                      type="text"
                      className="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg   block w-full py-2 pr-10    "
                      controlId="formBasicName"
                      placeholder={uiT("orders.datatable_templating_demo.full_name")}
                      value={dataForm.name}
                      onChange={(e) =>
                        setDataForm({ ...dataForm, name: e.target.value })
                      }
                      required
                    />
                  </div>
                </div>
                <div>
                  <label className="text-[#444] text-[13px] font-medium mb-1">
                    {uiT("ui.email")}
                  </label>
                  <div className="relative mb-1">
                    <div className="absolute inset-y-0 start-0 flex items-center ps-3.5 pointer-events-none">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#d5d5d5" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-mail"><rect width="20" height="16" x="2" y="4" rx="2" /><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" /></svg>
                    </div>
                    <input
                      type="text"
                      className="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg   block w-full py-2 pr-10    "
                      placeholder={uiT("ui.email")}
                      value={dataForm.email}
                onChange={(e) =>
                  setDataForm({ ...dataForm, email: e.target.value })
                }
                      disabled
                    />
                  </div>
                </div>

                <div>
                  <label className="text-[#444] text-[13px] font-medium mb-1">
                    {uiT("phone")}
                  </label>
                  <div className="relative mb-1">
                    <div className="absolute inset-y-0 start-0 flex items-center ps-3.5 pointer-events-none ">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#d5d5d5" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-phone"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" /></svg>
                    </div>
                    <input
                      className="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg   block w-full py-2 pr-10  text-right  "
                      type="tel"
                      placeholder={uiT("phone")}
                      controlId="formBasicPhone"
                      value={dataForm.phone}
                      onChange={(e) =>
                        setDataForm({ ...dataForm, phone: e.target.value })
                      }
                    />
                  </div>
                </div>



              </div>
            </div>


          </div>
        </div>

        <div className="border border-gray-300 rounded-lg w-full bg-white flex flex-col gap-2 my-3">
                  {/* Header */}
                  <div className="flex items-center justify-between bg-[#fbf5ff] p-2 rounded-lg border-b border-[#eee] ">
                    <div className="flex items-center gap-2">
                      <button className="text-red-500 hover:text-red-700 p-1">
                        <span className="text-xl">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#d5d5d5" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-calculator"><rect width="16" height="20" x="4" y="2" rx="2"/><line x1="8" x2="16" y1="6" y2="6"/><line x1="16" x2="16" y1="14" y2="18"/><path d="M16 10h.01"/><path d="M12 10h.01"/><path d="M8 10h.01"/><path d="M12 14h.01"/><path d="M8 14h.01"/><path d="M12 18h.01"/><path d="M8 18h.01"/></svg>
                                        </span>
                      </button>
                      <span className="text-gray-700 font-medium">
                        {" "}
                        {uiT("ui.confirmerBilling")}
                      </span>
                    </div>
                    <div className="flex items-center gap-2">
                      <OverlayTrigger
                        placement="top"
                        overlay={
                          <Tooltip>
                            {" "}
                            {uiT("ui.confirmerBillingHelp")}
                          </Tooltip>
                        }
                      >
                        <i className="bi bi-info-circle-fill text-[#0866ff] text-xl"></i>
                      </OverlayTrigger>
                    </div>
                  </div>
                  <div className="row gap-3  p-2">
                    <div className="flex flex-nowrap items-center gap-3 w-full">
                      <div className="grid grid-cols-2 md:grid-cols-3 gap-2">
                        <div>
                          <label className="text-[#444] text-[13px] font-medium mb-1">
                          {uiT("ui.billingMethod")}
                          </label>
                          <div className="relative mb-6">
                            <div className="absolute inset-y-0 start-0 flex items-center ps-3.5 pointer-events-none">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#d5d5d5" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-captions"><rect width="18" height="14" x="3" y="5" rx="2" ry="2"/><path d="M7 15h4M15 15h2M7 11h2M13 11h4"/></svg>
                                                </div>
                            <div className="mb-3 col-12 sm:col-3">
                              <select
                              disabled
                                placeholder={uiT("ui.billingMethod")}
                                value={dataForm.modePayement}
                onChange={(e) =>
                  setDataForm({ ...dataForm, modePayement: e.target.value })
                }
                                className="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg   block w-full py-2 pr-10   "
                              >

                                <option value="">{uiT("foorchat.stats.paymentMethod")}</option>
                                <option value="foorPay">{uiT("ui.perOrder")}</option>
                                <option value="handByHand">{uiT("ui.monthlyPay")} </option>
                              </select>
                            </div>
                          </div>
                        </div>
                        {dataForm?.modePayement === "foorPay" && (
                          <>
                            <div>
                              <label className="text-[#444] text-[13px] font-medium mb-1">
                                {uiT("ui.confirmedOrderPrice")}
                              </label>
                              <div className="relative mb-6">
                                <div className="absolute inset-y-0 start-0 flex items-center ps-3.5 pointer-events-none">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#d5d5d5" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-package-check"><path d="m16 16 2 2 4-4"/><path d="M21 10V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l2-1.14"/><path d="m7.5 4.27 9 5.15"/><polyline points="3.29 7 12 12 20.71 7"/><line x1="12" x2="12" y1="22" y2="12"/></svg>
                                </div>
                                <input
                                  controlId="formBasicConfirmPrice"
                                  type="number"
                                  placeholder={uiT("ui.confirmedOrderPrice")}
                                  value={dataForm.pricing.confirmPrice}
                    onChange={(e) =>
                      setDataForm({
                        ...dataForm,
                        pricing: {
                          ...dataForm.pricing, // نسخ القيم الأخرى داخل pricing
                          confirmPrice: parseInt(e.target.value, 10), // تحديث سعر التأكيد
                        },
                      })
                    }
                                  className="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg   block w-full py-2 pr-10    "
                                />
                              </div>
                            </div>
                            <div>
                              <label className="text-[#444] text-[13px] font-medium mb-1">
                                {uiT("ui.cancelledOrderPrice")}
                              </label>
                              <div className="relative mb-6">
                                <div className="absolute inset-y-0 start-0 flex items-center ps-3.5 pointer-events-none">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#d5d5d5" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-square-x"><rect width="18" height="18" x="3" y="3" rx="2" ry="2"/><path d="m15 9-6 6"/><path d="m9 9 6 6"/></svg>
                                </div>
                                <input
                                  type="number"
                                  controlId="formBasicCancelPrice"
                                  placeholder={uiT("ui.cancelledOrderPrice")}
                                  value={dataForm.pricing.cancelPrice}
                                  onChange={(e) =>
                                    setDataForm({
                                      ...dataForm,
                                      pricing: {
                                        ...dataForm.pricing, // نسخ القيم الأخرى داخل pricing
                                        cancelPrice: parseInt(e.target.value, 10), // تحديث سعر الإلغاء
                                      },
                                    })
                                  }
                                  className="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg   block w-full py-2 pr-10    "
                                />
                              </div>


                            </div>
                          </>
                        )}

                        {dataForm?.modePayement === "handByHand" && (
                          <>
                           <div>
                              <label className="text-[#444] text-[13px] font-medium mb-1">
                              {uiT("ui.monthlySalary")}
                              </label>
                              <div className="relative mb-6">
                                <div className="absolute inset-y-0 start-0 flex items-center ps-3.5 pointer-events-none">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#d5d5d5" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-hand-coins"><path d="M11 15h2a2 2 0 1 0 0-4h-3c-.6 0-1.1.2-1.4.6L3 17"/><path d="m7 21 1.6-1.4c.3-.4.8-.6 1.4-.6h4c1.1 0 2.1-.4 2.8-1.2l4.6-4.4a2 2 0 0 0-2.75-2.91l-4.2 3.9"/><path d="m2 16 6 6"/><circle cx="16" cy="9" r="2.9"/><circle cx="6" cy="5" r="3"/></svg>
                                </div>

                                <input
                                    type="number"
                                    controlId="formBasicConfirmPrice"
                                    placeholder={uiT("ui.monthlySalary")}
                                    value={dataForm.handByHand}
                                    onChange={(e) =>
                                      setDataForm({
                                        ...dataForm,
                                        handByHand: parseInt(e.target.value),
                                      })
                                    }
                                    disabled
                                  className="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg   block w-full py-2 pr-10    "
                                />
                              </div>


                            </div>

                          </>
                        )}




                      </div>
                    </div>


                  </div>
                </div>

        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            onClick={() => setLgShowE(false)}
            className="w-full mt-2 p-2.5 flex-1 text-gray-800 rounded-md outline-none border ring-offset-2 ring-purple-400 focus:ring-2"
          >
            {uiT("annule")}
          </button>
          <button
            type="submit"
            className="w-full mt-2 p-2.5 flex-1 text-white bg-[#a070b9] rounded-md outline-none ring-offset-2 ring-purple-400 focus:ring-2"
          >
            {uiT("ship.edit")}
          </button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default ModalAdd;
